import React from "react";
const PageNotFound = (props) => {
	return (
		<div className="flex items-center justify-center h-screen w-full bg-black">
			<h1 className="text-center text-white px-6 border-r">404</h1>
			<h2 className="text-center text-white px-6 font-extralight">This page could not be found.</h2>
		</div>
	);
};
export default PageNotFound;